import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import LinkPreviewStack from "../LinkPreviewStack";
import "./index.scss";

export default function ContentWithLinkPreviews({
    children,
    previewUrls = [],
    className = "",
    previewClassName = "",
}) {
    return (
        <div className={classNames("content-with-link-previews", className)}>
            {children}
            <LinkPreviewStack urls={previewUrls} className={previewClassName} />
        </div>
    );
}

ContentWithLinkPreviews.propTypes = {
    children: PropTypes.node.isRequired,
    previewUrls: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    previewClassName: PropTypes.string,
};
